/* eslint-disable import/prefer-default-export */
import convert from 'color-convert'

function hexToRgb(hex) {
  let updatedHex = hex.replace(/^#/, '')

  // If the HEX code is 3 characters, convert it to 6 characters
  if (updatedHex.length === 3) {
    updatedHex = updatedHex
      .split('')
      .map((char) => char + char)
      .join('')
  }

  const r = parseInt(updatedHex.slice(0, 2), 16)
  const g = parseInt(updatedHex.slice(2, 4), 16)
  const b = parseInt(updatedHex.slice(4, 6), 16)

  return [r, g, b]
}

function calculateLuminance(rgb) {
  const [r, g, b] = rgb.map((x) => x / 255)
  // Apply the luminance formula (ITU-R BT.709)
  const a = [r, g, b].map((v) =>
    v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4,
  )
  return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2]
}

function generateColors({
  count = 30,
  saturationMultiplier = 50,
  brightnessMultiplier = 30,
} = {}) {
  const generatedColors = []

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < count; i++) {
    const hue = (i * 360) / count
    const randomSaturation = 50 + Math.random() * saturationMultiplier
    const randomBrightness = 50 + Math.random() * brightnessMultiplier
    const color = convert.hsl.hex([hue, randomSaturation, randomBrightness])
    generatedColors.push(`#${color}`)
  }

  return generatedColors
}

function generageVisibleTextColor({ hexBackground }) {
  const rgb = hexToRgb(hexBackground)
  const luminance = calculateLuminance(rgb)
  // Return white if luminance is less than 0.5 (dark background), otherwise black
  return luminance < 0.5 ? '#FFFFFF' : '#000000'
}

export { generageVisibleTextColor, generateColors }
